export default __webpack_public_path__ + "static/device-5dfc3fbc1f0a3e927b383b5e184a39a1.png";